import loopbackProvider from 'react-admin-loopback';
import CONFIG from './config';

const dataProvider = loopbackProvider(CONFIG.apiUrl);
export default (type, resource, params) => 
  new Promise(resolve =>
        setTimeout(() => resolve(dataProvider(type, resource, params)), 500)
    );
